module.exports = __webpack_public_path__ + "img/darkInactive.f5306d6c.svg";